import { useDispatch, useSelector } from 'react-redux';
import { Snackbar, Alert as MuiAlert, useMediaQuery, useTheme } from '@mui/material';

import useTranslate from 'hooks/useTranslate';
import { clearAlert } from 'redux/alert';
import { RootState } from 'redux/store';

const AppAlert = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const { translate } = useTranslate();

    const { type, message } = useSelector((state: RootState) => state.alert);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleClearAlert = () => {
        dispatch(clearAlert());
    };

    if (!message) {
        return null;
    }

    return (
        <Snackbar
            open
            onClose={handleClearAlert}
            autoHideDuration={5000}
            sx={{ zIndex: 99999 }}
            anchorOrigin={
                isMobile
                    ? { vertical: 'bottom', horizontal: 'center' }
                    : { vertical: 'top', horizontal: 'right' }
            }
        >
            <MuiAlert
                onClose={handleClearAlert}
                severity={type || 'info'}
                elevation={6}
                sx={{
                    width: '100%',
                    whiteSpace: 'pre-line',
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.25)',
                }}
            >
                {translate(message)}
            </MuiAlert>
        </Snackbar>
    );
};

export default AppAlert;
